/* unplugin-vue-components disabled */import script from "./title_label.vue?vue&type=script&setup=true&lang=js"
export * from "./title_label.vue?vue&type=script&setup=true&lang=js"

import "./title_label.vue?vue&type=style&index=0&id=dc3262aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc3262aa"]])

export default __exports__